import { portfolioConfig } from '../../../config';

export interface Project {
  id: number;
  title: string;
  description: string;
  link: string;
}

export const projectData: Project[] = portfolioConfig.projects.map((project) => ({
  id: Number(project.id),
  title: project.title,
  description: project.description ?? '',
  link: project.repoUrl,
}));
